module.exports = __webpack_public_path__ + "static/media/buy-course-bg.08be8f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/static/img/buy-course-bg.png
// module id = 213
// module chunks = 1